import { BeneficiaryEntitiyDetails } from './beneficiaryEntitiyDetails';

export default BeneficiaryEntitiyDetails;